class ScrollReveal extends HTMLElement {
    constructor() {
        super();
        this.hasAppeared = false; // Track if the element has been in the viewport
    }

    connectedCallback() {

        if (document.body.classList.contains('page-homepage')) {
            // Skip scroll reveal logic on home page
            this.style.opacity = '1';
            this.style.transform = 'none'; // optional, reset any transform
            return;
        }
        this.scrollProgress();
    }

    scrollProgress() {
        /**
       * Hat tip: https://gomakethings.com/debouncing-events-with-requestanimationframe-for-better-performance/
       */
        const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;

        // Used for debounce
        let timeout;

        const calculateValues = () => {
            const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

            // If there's a timer, cancel it
            if (timeout) {
                window.cancelAnimationFrame(timeout);
            }

            const rect = this.getBoundingClientRect();
            const elementHeight = rect.height || this.offsetHeight;
            const visibleHeight = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
            const isInViewport = visibleHeight / elementHeight >= 0.2; // Check if at least 20% of the element is visible

            // Setup the new requestAnimationFrame()
            timeout = window.requestAnimationFrame(() => {
                const scrollPercentage = Math.round((scrollTop / height) * 100);
                this.dataset.scrollPercentage = scrollPercentage;
                this.dataset.isInViewport = isInViewport;

                // If the element has appeared in the viewport at least once
                if (isInViewport && !this.hasAppeared) {
                    this.hasAppeared = true;
                    this.dataset.hasAppeared = 'true';
                }
            });
        };

        calculateValues();
        window.addEventListener('scroll', calculateValues);
    }
}

customElements.define('scroll-reveal', ScrollReveal);
